<template>
  <path
    d="M18 2.00024H6C4.9 2.00024 4 2.90024 4 4.00024V20.0002C4 21.1002 4.9 22.0002 6 22.0002H18C19.1 22.0002 20 21.1002 20 20.0002V4.00024C20 2.90024 19.1 2.00024 18 2.00024ZM15.5 13.5002C14.67 13.5002 14 12.8302 14 12.0002C14 11.1702 14.67 10.5002 15.5 10.5002C16.33 10.5002 17 11.1702 17 12.0002C17 12.8302 16.33 13.5002 15.5 13.5002Z"
  />
</template>
